export default __webpack_public_path__ + "static/media/chainwars_purple_logo.d3de1707.svg";